import { useAuthQuery } from '@/services/auth';
import { AuditLogsPageContainer } from './components/AuditLogsPageContainer';

export const AccountAuditLogs = () => {
  const auth = useAuthQuery();
  const currentAccountId = auth.data?.account?.id;

  return (
    <AuditLogsPageContainer
      context="account"
      contextId={currentAccountId}
      breadcrumbs={[{ text: 'Settings', href: '/settings' }, { text: 'Audit logs' }]}
      pageTitle="Audit Logs"
      pageDescription="View audit logs to track account-level changes."
      backUrlBase="/settings/audit-logs"
      feedbackFeature="Account Audit Logs"
    />
  );
};
